import React, { useState, useEffect } from "react";
import "../styling/transactionhistory.css";
import { X } from "lucide-react";
import API from "../utils/api"; // ✅ import your axios instance
import moment from "moment";
const TransactionHistory = ({ loan, onClose }) => {
  console.log("Loan info is", loan);
  const [transactions, setTransactions] = useState([]);
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");
  const [type, setType] = useState("Credit");
  const [totalCredit, setTotalCredit] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [date, setDate] = useState("");

  // ✅ Fetch existing transactions for this loan
  useEffect(() => {
    const fetchTransactions = async () => {
      if (!loan?._id) return;
      try {
        const { data } = await API.get(`/transactions/${loan._id}`);
        setTransactions(data);
        calculateTotals(data);
      } catch (err) {
        console.error("Error fetching transactions:", err);
      }
    };
    fetchTransactions();
  }, [loan]);

  const calculateTotals = (list) => {
    const credit = list
      .filter((t) => t.type.toLowerCase() === "credit")
      .reduce((sum, t) => sum + parseFloat(t.amount || 0), 0);
    const debit = list
      .filter((t) => t.type.toLowerCase() === "debit")
      .reduce((sum, t) => sum + parseFloat(t.amount || 0), 0);
    setTotalCredit(credit);
    setTotalDebit(debit);
  };

  // ✅ Add transaction via API
  const handleAddTransaction = async () => {
    if (!amount || !message || !date) return alert("Please fill all fields!");
    try {
      const { data } = await API.post("/transactions", {
        loanId: loan._id,
        amount: parseFloat(amount),
        message,
        type,
        date,
      });
      const updated = [...transactions, data];
      setTransactions(updated);
      calculateTotals(updated);
      setAmount("");
      setMessage("");
      setDate("");
    } catch (err) {
      console.error("Error adding transaction:", err);
      alert("Failed to add transaction");
    }
  };

  // ✅ Delete transaction via API
  const handleDelete = async (id) => {
    try {
      await API.delete(`/transactions/${id}`);
      const updated = transactions.filter((t) => t._id !== id);
      setTransactions(updated);
      calculateTotals(updated);
    } catch (err) {
      console.error("Error deleting transaction:", err);
      alert("Failed to delete transaction");
    }
  };

  return (
    <div className="transaction-overlay">
      <div className="transaction-container">
        <button className="close-btn" onClick={onClose}>
          <X size={22} />
        </button>
        <h2 className="title">Transaction History</h2>

        <div className="transaction-form">
          <div className="form-group">
            <label className="input-label">Enter Amount</label>
            <input
              type="number"
              placeholder="Enter amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="input-label">Enter Message</label>
            <input
              type="text"
              placeholder="Enter message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="input-label">Select Date</label>
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="Credit">Credit</option>
            <option value="Debit">Debit</option>
          </select>
          <button className="add-btn" onClick={handleAddTransaction}>
            Add Transaction
          </button>
        </div>

        <div className="totals">
          <p>
            <strong>Total Credit:</strong> ₹{totalCredit.toFixed(2)}
          </p>
          <p>
            <strong>Total Debit:</strong> ₹{totalDebit.toFixed(2)}
          </p>
        </div>

        <div className="transaction-list">
          {transactions.length > 0 ? (
            transactions.map((t) => (
              <div key={t._id || t.id} className={`transaction-card ${t.type}`}>
                <div style={{ width: "90%" }}>
                  <p className="amt">₹{t.amount}</p>
                  <p>{t.message}</p>
                  <p className="date">{moment(t.date).format("DD/MM/YYYY")}</p>
                </div>
                <button
                  className="delete-btn"
                  onClick={() => handleDelete(t._id || t.id)}
                >
                  Delete
                </button>
              </div>
            ))
          ) : (
            <p className="empty-text">No transactions yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransactionHistory;
